<template>
  <nav class="large-box-links inner" v-if="pages.length !== 0 || custom_urls.length !== 0">
    <ul>
      <li v-for="(item, index) in pages" :key="'a' + index">
        <Link :post_link="item.link">
          <figure v-if="!hide_image && item.featured_image">
            <img :alt="item.post_title" :src="item.featured_image.medium_4x3">
          </figure>
          <h3 v-html="item.post_title"></h3>
        </Link>
      </li>
      <li v-for="(item, index) in custom_urls" :key="'b' + index" v-if="item.title && item.link">
        <Link :post_link="item.link" :new_window="item.is_new_window">
          <figure v-if="!hide_image && item.image && item.image.sizes.medium_4x3">
            <img :src="item.image.sizes.medium_4x3" :alt="item.image.alt">
          </figure>
          <h3 v-html="item.title"></h3>
        </Link>
      </li>
    </ul>
  </nav>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
  name: 'large-box-links',

  components: {
    Link,
  },

  props: {
    data: {
      type: Object,
      default: [],
    }
  },

  data() {
    return {
      pages: [],
      custom_urls: [],
      hide_image: false,
    }
  },

  mounted() {
    console.log(this.data)
    this.pages = this.data?.related_pages
    this.custom_urls = this.data?.custom_urls
  }
}

</script>

<style lang="scss">
.large-box-links {
  padding: var(--padding-x2) 0;

  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -2.25rem;

    li {
      padding: var(--padding) var(--padding);
      box-sizing: border-box;
      width: 50%;

      figure {
        display: block;
        width: 100%;
        position: relative;

        &::before {
          content: '';
          display: block;
          padding-bottom: 75%;
        }
      }

      img {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        object-fit: cover;
        top: 0;
        left: 0;
      }

      h3 {
        font-size: var(--medium-size);
        line-height: 1.2;
        padding: var(--padding-50) var(--padding) var(--padding);
      }

      a {
        display: block;
        background-color: var(--gray);

        &:hover {
          color: white;
          background: black;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .large-box-links {
    padding: var(--padding) 0;

    ul {
      margin: 0;

      li {
        padding: var(--padding-50) 0;
        width: 100%;

        h3 {
          padding: var(--padding-50);
        }
      }
    }
  }
}
</style>
